import React from "react";
import { Icon } from "@mc/mc-legacy";
import { Col, Row } from "reactstrap";
import PropTypes from "prop-types";
import "./RegistrationContent.scss";

class RegistrationContent extends React.Component<any> {
  static propTypes = {
    icon: PropTypes.string,
    betweenBorder: PropTypes.bool,
  };
  static defaultProps = {
    betweenBorder: true,
  };

  renderIcon() {
    const { icon } = this.props;

    if (icon) {
      return <img src={`${(window as any).serverContextPath}/res/zr-${icon}.png`} alt="Ikonka moje ID" />;
    }

    return <Icon icon={"times-circle"} className={"text-danger"} />;
  }

  renderChildren() {
    const { children, betweenBorder } = this.props;

    if (betweenBorder) {
      return <div className={"py-3 pl-4" + (betweenBorder ? " border-left" : "")}>{children && children}</div>;
    }

    return children && children;
  }

  render() {
    const { betweenBorder } = this.props;
    return (
      <Row className={"registration-content my-4"} noGutters>
        <Col xs={3} className={"p-4 d-flex justify-content-center" + (betweenBorder ? " align-items-center" : "")}>
          {this.renderIcon()}
        </Col>
        <Col xs={9} className={"py-4 pr-4 pl-0 pt-3"}>
          {this.renderChildren()}
        </Col>
      </Row>
    );
  }
}

export default RegistrationContent;
